import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

interface BackupStatus {
  loading: boolean;
  backedUp?: boolean;
}

function useBackupStatus(): BackupStatus {
  const backedUp = useSelector<unknown, boolean | undefined>(
    selectors.wallet.backedUp,
  );

  if (backedUp === undefined) {
    return { loading: true };
  }

  return {
    backedUp,
    loading: false,
  };
}

export default useBackupStatus;
